import React from "react";
import { useSelector } from "react-redux";

import { GameInformationGameExpectationsDataType, TargetPlatform } from "../../../../models/forms";
import { TargetPlatforms, TargetPlatformsDisplayName } from "../../../../models/targetPlatforms";
import { getMiddlewareEngines } from "../../../../redux/selectors";
import { FieldOption } from "../../../../server/crm/api/models/forms";
import { getDateStringForReadOnlyForm, ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type ReadOnlyIdXboxGameExpectationsProps = {
  dataInForm: GameInformationGameExpectationsDataType;
};

const IdXboxGameExpectationsConfig: Map<string, ReadOnlyFormItem> = new Map([
  [
    "targetPlatforms",
    {
      title: "targetSystemsAndPlatforms",
      mapper: (
        data: GameInformationGameExpectationsDataType,
        localizedStrings: Map<string, string>
      ) =>
        data.targetPlatforms
          .filter(function (x: { selected: boolean }) {
            return x.selected;
          })
          .map((item: TargetPlatform) => {
            let platformName: string | undefined = "";
            switch (item.platform) {
              case TargetPlatforms.windowsStore:
                platformName = localizedStrings.get("microsoftStoreOnWindowsPlatform");
                break;
              case TargetPlatforms.other:
                platformName = item.otherPlatformName;
                break;
              default:
                platformName = TargetPlatformsDisplayName[item.platform];
                break;
            }
            return `${platformName} : ${getDateStringForReadOnlyForm(item.releaseDate)}`;
          }),
    },
  ],
  [
    "middleware",
    {
      title: "middlewareEngine",
      mapper: (
        data: GameInformationGameExpectationsDataType,
        _localizedStrings: Map<string, string>,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        additionalData?: Map<string, any>
      ) => {
        if (!additionalData) {
          return null;
        }
        const crmMiddlewareEnginesList = additionalData.get(
          "crmMiddlewareEnginesList"
        ) as FieldOption[];
        return crmMiddlewareEnginesList.find(
          middlewareItem => middlewareItem.id === data.middleware
        )?.value;
      },
    },
  ],
  [
    "middlewareVersion",
    {
      title: "currentVersion",
    },
  ],
  [
    "middlewareNotes",
    {
      title: "additionalMiddlewareNotes",
    },
  ],
  ["releaseNotes", {}],
]);

export const ReadOnlyIdXboxGameExpectations = ({
  dataInForm,
}: ReadOnlyIdXboxGameExpectationsProps) => {
  const extraStringsToLocalize = [
    "targetSystemsAndPlatforms",
    "middlewareEngine",
    "currentVersion",
    "additionalMiddlewareNotes",
    "releaseNotes",
    "microsoftStoreOnWindowsPlatform",
  ];

  const crmMiddlewareEnginesList = useSelector(getMiddlewareEngines);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const additionalData = new Map<string, any>([
    ["crmMiddlewareEnginesList", crmMiddlewareEnginesList],
  ]);

  return (
    <ReadOnlyForm
      formConfig={IdXboxGameExpectationsConfig}
      formData={dataInForm}
      extraStringsToLocalize={extraStringsToLocalize}
      additionalData={additionalData}
    />
  );
};
